module.exports = __webpack_public_path__ + "media/images/redesign-images/higher-ed/image-2-9c38eeb8c96967355ddc94cc26fd1313.png";